export const DEFAULT_HISTORICO_LIST_ID = 0;
export const DEFAULT_RESULTADO_LIST_ID = 1;

export const isDefinedListId = (value: unknown): value is number =>
    value !== null && value !== undefined && value !== '';

export const resolveHistoricoListId = (
    lists: Array<{ id: number; type?: number }> = []
): number => {
    const match = lists.find((item) => item.type === 1);
    return match?.id ?? DEFAULT_HISTORICO_LIST_ID;
};
